/**
 * KAN-735: плашка расходов над дашбордом, только владельцу: одна строка
 * "Расходы за <месяц>: X ₽ · прокси · аккаунты · токены · баланс OpenRouter"
 * и ссылка на /expenses. Ошибка или чужой ответ: плашки нет, дашборд не страдает.
 */
import { Link } from 'react-router-dom';
import { Wallet } from 'lucide-react';
import { useIsOwner } from '@/hooks/useCurrentUser';
import { useSafeExpenses } from '@/hooks/useExpenses';
import { currentMonth, expensesSummaryLine } from '@/lib/expenses';

export function ExpensesSummaryBanner(): JSX.Element | null {
  const isOwner = useIsOwner();
  const report = useSafeExpenses(currentMonth(), isOwner);
  if (!isOwner || !report) return null;
  return (
    <div
      className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border bg-white px-4 py-2 text-sm text-gray-700"
      data-testid="expenses-banner"
    >
      <Wallet className="h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden />
      <span className="tabular-nums">{expensesSummaryLine(report)}</span>
      <Link to="/expenses" className="text-blue-700 hover:underline">
        Подробнее
      </Link>
    </div>
  );
}
